import styled, {css} from 'styled-components';

import {
  ActionButtonDropdown,
  ActionButton as BaseActionButton,
  Button,
  InfoDropdown,
} from '@edna/components';
import {Icon} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';
import {TSpacingSize} from '@edna/components/types';
import BaseMoreHorizIcon from '@edna/icons/moreHoriz.svg';

import {InlineLinkButton as BaseInlineLinkButton, Link, Text} from 'src/components/primitives';

export const Card = styled.div`
  position: relative;
  display: grid;
  width: 100%;

  ${({theme}) => css`
    grid-template-columns: 140px calc(100% - 140px - ${theme.spacing.s4});
    gap: ${theme.spacing.s4};
    padding: ${theme.spacing.s4};
    border: 1px solid ${theme.palette.grey200};
    border-radius: ${theme.borderRadius.br2};
  `};
`;

export const ActionButton = styled(BaseActionButton)`
  ${({theme}) => css`
    border-width: ${theme.spacing.s05};
  `};
`;

export const FloatingDropdown = styled(ActionButtonDropdown)`
  position: absolute;
  right: ${({theme}) => theme.spacing.s4};
  margin-left: ${({theme}) => theme.spacing.s4};
`;

export const ChannelLabel = styled.div`
  width: fit-content;
  height: fit-content;
  ${mixins.stack({direction: 'ROW', size: '1'})}
  ${({theme}) => css`
    padding: ${theme.spacing.s1} ${theme.spacing.s2};
    border: 1px solid ${theme.palette.grey400};
    border-radius: ${theme.borderRadius.br8};
  `};
`;

export const MoreHorizIcon = styled(BaseMoreHorizIcon)`
  transform: rotate(90deg);
`;

export const Detail = styled(Text)<{stackSize?: TSpacingSize}>`
  ${({stackSize = '2'}) => mixins.stack({direction: 'ROW', size: stackSize, align: 'center'})}
  flex-wrap: wrap;
`;

export const LeftIcon = styled(Icon)`
  margin-right: ${({theme}) => theme.spacing.s4};
`;

export const InlineLinkButton = styled(BaseInlineLinkButton)<{
  color?: TThemeColor;
  weight?: number;
}>`
  ${mixins.f2}
  ${mixins.stack({direction: 'ROW', size: '1', align: 'center'})}
  color: ${({theme, color = 'grey400'}) => theme.palette[color]};
  font-weight: ${({weight = 400}) => weight};
`;

export const PricingLink = styled(Link)`
  text-decoration: underline;
`;

export const Point = styled.div<{isBold?: boolean}>`
  ${mixins.stack({size: '2', direction: 'ROW', align: 'center'})};

  ${({isBold}) =>
    isBold &&
    css`
      font-weight: 700;
    `};
`;

export const ConnectButton = styled(Button)`
  margin-top: ${({theme}) => theme.spacing.s1};
`;

export const TariffTitle = styled.div`
  ${mixins.stack({size: '2', direction: 'ROW'})};
  ${mixins.f6};

  font-weight: 500;
  margin-bottom: ${({theme}) => theme.spacing.s2};
  overflow-wrap: anywhere;
`;

export const TariffWrapper = styled.div<{count?: number; gap?: number}>`
  ${mixins.stack({size: '2'})};
  width: 100%;
  min-width: 341px;
  max-width: 468px;

  ${({theme}) => css`
    padding: ${theme.spacing.s5} ${theme.spacing.s6};
    box-shadow: inset 0 0 0 1px ${theme.palette.grey100};
    border-radius: ${theme.borderRadius.br2};
    transition: all ${theme.animation.duration / 2}ms;

    &:hover {
      box-shadow: inset 0 0 0 1px ${theme.palette.green400};
    }
  `};

  ${({count = 1, gap = 0}) => {
    if (count <= 1) {
      return;
    }

    const columns = Math.min(3, count);
    const width = `calc((1022px - ${gap}px * ${columns - 1}) / ${columns})`;

    return css`
      width: ${width};
      min-width: ${width};
    `;
  }}
`;

export const PriceWithHint = styled.div`
  white-space: nowrap;
`;

export const Hint = styled(InfoDropdown)`
  ${({theme}) => css`
    top: ${theme.spacing.s1};
    margin-left: ${theme.spacing.s1};
  `};
`;
